import { render, staticRenderFns } from "./promoteStatus.vue?vue&type=template&id=8cf1647e&scoped=true"
import script from "./promoteStatus.vue?vue&type=script&lang=js"
export * from "./promoteStatus.vue?vue&type=script&lang=js"
import style0 from "./promoteStatus.vue?vue&type=style&index=0&id=8cf1647e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf1647e",
  null
  
)

export default component.exports